import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { SendFinalSaleStates } from "./types/SendFinalSaleTypes ";
import { bqApiService } from "../../services/otodis/BqApiService";
import { orderService } from "../../services/otodisApi/OrderService";
import { Button, Col, DatePicker, Form, Modal, Result, Row, Select, Spin, Table, Tabs, Tooltip } from "antd";
import { CloudServerOutlined, CloudSyncOutlined, LeftOutlined, SaveOutlined } from "@ant-design/icons";
import moment from "moment";
import { Typography } from "antd";

const { Text } = Typography;

const { TabPane } = Tabs;

export interface SendFinalSaleProps {}

class SendFinalSale extends Component<SendFinalSaleProps & any, SendFinalSaleStates> {
  private readonly initState!: SendFinalSaleStates;
  private tableOrderColumn: any = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      width: 170,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`}>{value}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "No SPK",
      dataIndex: "amh_order_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value}`}</span>;
      },
    },
    {
      title: "Nama BPKB & Nama Konsumen",
      dataIndex: "customer_name",
      width: 150,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.customer_doc_name}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${value}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tgl Order & Tgl Delivery",
      dataIndex: "order_create_date",
      width: 120,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.order_create_date}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${row.order_delivery_date}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Nomor Mesin | Nomor Rangka",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${value} - ${row.vehicle_chassis_number}`}</span>;
      },
    },
    {
      title: "Tipe Motor",
      dataIndex: "vehicle_variant_code",
      width: 100,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${value}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${row.vehicle_variant_name}`}</span>
          </React.Fragment>
        );
      },
    },
  ];
  private tableColumn: any = [
    {
      title: "Order Code",
      dataIndex: "orderCode",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nama BPKB",
      dataIndex: "customerDocName",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nama Pemesan",
      dataIndex: "customerName",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nomor Mesin",
      dataIndex: "engineNumber",
      render: (value: string) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Keterangan",
      dataIndex: "description",
      render: (value: string) => {
        return <span className={`font-90`}>{value === "SUCCESS" ? <Text type="success">{value}</Text> : <Text type="danger">{value}</Text>}</span>;
      },
    },
  ];

  constructor(props: (SendFinalSaleProps & any) | any) {
    super(props);
    this.initState = {
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      startDate: moment().clone().format("YYYY-MM"),
      orderMonth: moment().clone().format("YYYY-MM"),
      fetchPost: false,
      dataPost: [],
      filterOrderStatus: null,
      tabKey: "1",
      finalLoadingModal: false,
      saveProcessing: false,
      modalConfirm: false,
      modalResult: false,
      listResult: [],
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
      processingFetchTableData: false,
      dataOrder: [],
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onchangeStartDate = (data: any) => {
    if (data) {
      this.setState({
        startDate: data,
      });
    }
  };

  cancelProcess = async () => {
    await this.promisedSetState({
      tabKey: "1",
      dataPost: [],
    });
  };

  sendToFinalSale = async () => {
    if (!this.state.filterOrderStatus) {
      Modal.error({
        title: "Error",
        content: "Lengkapi Status Order",
      });
      return;
    }

    await this.promisedSetState({
      fetchPost: true,
      listResult: [],
      finalLoadingModal: true,
    });

    try {
      await bqApiService
        .SendFinalSale({
          dealerCode: this.state.dealerCode,
          startDate: moment(this.state.startDate).startOf("month").format("YYYY-MM-DD"),
          endDate: moment(this.state.startDate).endOf("month").format("YYYY-MM-DD"),
          transferTitleStatus: this.state.filterOrderStatus,
        })
        .then(async (value) => {
          const dataFinal = [];

          const failedData = value.data.success.data_failed;
          for (const orderCode in failedData) {
            dataFinal.push({
              orderCode: orderCode,
              customerDocName: "",
              customerName: "",
              engineNumber: "",
              description: failedData[orderCode]?.toString(),
            });
          }

          for (const item of value.data.success.data_success) {
            dataFinal.push({
              orderCode: item?.order_otodis_code,
              customerDocName: item?.customer_doc_name,
              customerName: item?.customer_name,
              engineNumber: item?.vehicle_engine_number,
              description: "SUCCESS",
            });
          }

          console.log(dataFinal);

          await this.promisedSetState({
            tabKey: "2",
            fetchPost: false,
            finalLoadingModal: false,
            dataPost: dataFinal,
          });
        });
    } catch (e) {
      await this.promisedSetState({
        tabKey: "1",
        fetchPost: false,
        finalLoadingModal: false,
        dataPost: [],
      });
      Modal.error({
        title: "Proses Gagal",
        content: "" + e,
      });
    }
  };

  callback = async (key: any) => {
    if (key === "0") {
      this.setState({
        tabKey: "0",
      });
    }
    if (key === "1") {
      this.setState({
        tabKey: "1",
      });
    }
  };

  onFieldChange = <T extends keyof Pick<any, "filterOrderStatus">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterOrderStatus":
        currentState.filterOrderStatus = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  onWarehouseStartDate = (data: any) => {
    this.setState({
      filterStartDate: data,
    });
  };

  onWarehouseEndDate = (data: any) => {
    this.setState({
      filterEndDate: data,
    });
  };

  fetchStockData = async () => {
    await this.promisedSetState({
      dataOrder: [],
      processingFetchTableData: true,
    });

    orderService
      .getOrder({
        dealerCode: this.state.dealerCode,
        dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        dataType: "create_date",
        statusOrder: "UNFINISHED",
      })
      .then(async (value) => {
        await this.promisedSetState({
          dataOrder: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataOrder: [],
          processingFetchTableData: false,
        });
      });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Order`} breadcrumbMenu={`Send Final Sale`} defaultSelectedKeys={["m-send-final-sale"]} defaultOpenKeys={["sm-order"]}>
          <Tabs activeKey={this.state.tabKey.toString()} onChange={this.callback}>
            <TabPane tab="Belum dilakukan Final Sale" key="0">
              <div style={{ padding: 24 }}>
                <Form layout={`inline`}>
                  <Form.Item label="" className={"padTop-10"}>
                    <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseStartDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                  <Form.Item label="" className={"padTop-10"}>
                    <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onWarehouseEndDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                  <Form.Item className={"padTop-10"}>
                    <Button onClick={this.fetchStockData} type="primary" icon={<CloudSyncOutlined />}>
                      {" "}
                      Go{" "}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
              <br />
              <Table
                rowKey={"order_code"}
                size={"small"}
                scroll={{ x: "calc(500px + 50%)" }}
                loading={this.state.processingFetchTableData}
                columns={this.tableOrderColumn}
                dataSource={this.state.dataOrder}
                pagination={{ pageSize: 100 }}
              />
            </TabPane>
            <TabPane tab="Send Final Sale" key="1">
              <Result
                icon={<CloudServerOutlined />}
                title="Send Data Final Sale"
                extra={
                  <div>
                    <Row>
                      <Col xs={24} xl={6} className={`pad-10`} />
                      <Col xs={24} xl={6} className={`pad-10`}>
                        <Form.Item>
                          <i className={`small-text-grey`}>Bulan Order</i>
                          <DatePicker picker="month" value={moment(this.state.startDate, "YYYY-MM")} onChange={(event) => this.onchangeStartDate(event)} format={"YYYY-MM"} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6} className={`pad-10`}>
                        <Form.Item>
                          <i className={`small-text-grey`}>Status Order</i>
                          <Select
                            showSearch
                            placeholder="Pilih Status"
                            optionFilterProp="children"
                            onChange={(value) => this.onFieldChange("filterOrderStatus", value)}
                            value={this.state.filterOrderStatus}
                          >
                            {/* <Select.Option key={`UPLOADED`} value={`UPLOADED`}>{`UPLOADED`}</Select.Option> */}
                            <Select.Option key={`GENERATED`} value={`GENERATED`}>{`GENERATED`}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6} className={`pad-10`} />
                    </Row>

                    <br />
                    <Button onClick={this.sendToFinalSale} loading={this.state.fetchPost} type="primary" icon={<SaveOutlined />}>
                      Send Final Sale
                    </Button>
                  </div>
                }
              />
            </TabPane>
            <TabPane tab="Data Final Sale" disabled={true} key="2">
              <div>
                <Tooltip title="Back">
                  <Button shape="circle" icon={<LeftOutlined />} onClick={this.cancelProcess} />
                </Tooltip>
              </div>
              <br />
              <br />

              <Table
                rowKey={"orderCode"}
                size={"small"}
                scroll={{ x: "calc(500px + 50%)" }}
                loading={this.state.fetchPost}
                columns={this.tableColumn}
                dataSource={this.state.dataPost}
                pagination={{ pageSize: 10000 }}
              />
            </TabPane>
          </Tabs>

          <Modal visible={this.state.finalLoadingModal} closeIcon={true} footer={null}>
            <div style={{ textAlign: "center", padding: 20, minHeight: 100 }}>
              <Spin style={{ marginTop: 20 }} size={"large"} tip="Processing..." />
            </div>

            <div style={{ textAlign: "center", padding: 20 }}>
              Proses kirim data final sale <br />
              Mohon menunggu beberapa saat.
            </div>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(SendFinalSale), 21);
